// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"146":"FSFolder","161":"FSActivity","368":"KCNotFound","505":"FSBase"}[chunkId] || chunkId) + "-legacy." + {"146":"83b15c94","161":"dc14b835","368":"ba810715","505":"d9197a49","690":"64b1873d","843":"90cb8bef","937":"99b4e7b0"}[chunkId] + ".js";
};